import { Box, Image, Text } from "@chakra-ui/react";
import { assets } from "../../assets";
import { colors } from "../../theme/tokens/colors";

const Selection = ({ icon, title, isSelected, onClick }: SelectionProps) => {
  const { tick: TickIcon } = assets.iconComponents;

  return (
    <Box
      as="button"
      width={"100%"}
      height={"4.25rem"}
      mb={".8rem"}
      boxShadow={isSelected ? colors.shadow.warning : "none"}
      borderRadius={"1.4rem"}
      border={`1px solid`}
      borderColor={`${isSelected ? "yellow.500" : "neutral.800"}`}
      bg={isSelected ? "whiteAlpha.200" : "tran"}
      px={"1.25rem"}
      py={"2.1rem"}
      onClick={onClick}
      sx={icon ? { display: "flex" } : { justifyContent: "center" }}
      display={"flex"}
      alignItems={"center"}
      cursor={"pointer"}
      _hover={{
        bg: "whiteAlpha.200",
      }}
    >
      <Box>{icon ? <Image src={icon} /> : <></>}</Box>
      <Box w="100%" ml={icon ? "1.375rem" : "0rem"}>
        <Text color={"whiteALpha.800"} textAlign={icon ? "left" : "center"}>
          {title}
        </Text>
      </Box>
      <Box
        style={{
          justifySelf: "flex-end",
          visibility: isSelected ? "visible" : "hidden",
        }}
      >
        <TickIcon className="icon-class" />
      </Box>
    </Box>
  );
};

export default Selection;
